export enum AuthenticationGrantTypes {
  AUTH_CODE = 'authorization_code',
  REFRESH_TOKEN = 'refresh_token'
}
